import React, {useEffect, useState, useRef } from "react";
import MapComponent from "../map/index";

import { useLazyEffect } from "../../hooks/common/useLazyEffect";
import { useDevices } from "../../hooks/useDevices";
import { usePanicButtons } from "../../hooks/usePanicButtons";
import Loading from 'react-fullscreen-loading';

import MapContextProvider from "../../contexts/mapContexts";

import "./index.css";
import InformationInterface from "../informationInterface";
import { CreateDevices } from "../../helper/DummyMarkerCreator";
import { DevicePopup } from "../informationInterface/devicePopup";



const dummyPeopleCount = {
  İstanbul : {
      Total: {
          value: 15529009,
          _indicator: "blue",
          _skip: true,
          0: [],
          1: [],
          2: []
      },
      Unaffected: {
          value: 15529009,
          _indicator: "green",
          0: [],
          1: [],
          2: []
      },
      Unsure: {
          value: 0,
          _indicator: "yellow",
          0: [],
          1: [],
          2: []
      },
      Affected: {
          value: 0,
          _indicator: "red",
          0: [],
          1: [],
          2: []
      },
  },
  District : {
      Beşiktaş : {
          Total: {
              value: 7450,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 7450,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          }
      },
      Others : {
          Total: {
              value: 2250,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 2250,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      }
  },
  Neighborhood : {
      Levent: {
          Total: {
              value: 346,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 346,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      },
      Akat: {
          Total: {
              value: 549,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 549,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      },
      Etiler: {
          Total: {
              value: 274,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 274,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      },
      Levazım: {
          Total: {
              value: 346,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 346,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      },
      Others: {
          Total: {
              value: 752,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 752,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      }
  }
}

const dummyBuildingCount = {
  İstanbul: {
      Total: {
          value: 10243,
          _indicator: "blue",
          _skip: true
      },
      Unaffected: {
          value: 10243,
          _indicator: "green",
          0: [],
          1: [],
          2: []
      },
      Unsure: {
          value: 0,
          _indicator: "yellow",
          0: [],
          1: [],
          2: []
      },
      Affected: {
          value: 0,
          _indicator: "red",
          0: [],
          1: [],
          2: []
      },
  },
  District: {
      Beşiktaş: {
          Total: {
              value: 1250,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 1250,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      },
      Others: {
          Total: {
              value: 2043,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 2043,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      }
  },
  Neighborhood: {
      Levent: {
          Total: {
              value: 23,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 23,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      },
      Akat: {
          Total: {
              value: 240,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 240,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      },
      Etiler: {
          Total: {
              value: 14,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 14,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      },
      Levazım: {
          Total: {
              value: 18,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 18,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      },
      Others: {
          Total: {
              value: 17,
              _indicator: "blue",
              _skip: true
          },
          Unaffected: {
              value: 17,
              _indicator: "green",
          },
          Unsure: {
              value: 0,
              _indicator: "yellow",
          },
          Affected: {
              value: 0,
              _indicator: "red",
          },
      }
  }
}

const dummyDatas = {
  building: dummyBuildingCount,
  people: dummyPeopleCount
}



export default function App() {
  const layerFunctions = useRef({});
  window.layerFunctions = layerFunctions;
  const allLayers = useRef({});
  window.allLayers = allLayers;
  const allMarkers = useRef({});
  window.allMarkers = allMarkers;


  const [devices, setDevices] = useState(null);
  window.devices = devices;
  const [deviceDifference, setDeviceDifference] = useState([]);
  const [loggedDevices, setLoggedDevices] = useState([]);
  window.loggedDevices = loggedDevices;

  //dummer[deviceDifference[i].ID]
  const [dummyData, setDummyData] = useState(dummyDatas);
  window.dummyData = dummyData;


  
  const [currentMarker, setCurrentMarker] = useState(undefined);
  window.currentMarker = currentMarker;
  window.setCurrentMarker = setCurrentMarker;

  const [panicButtons, setPanicButtons] = useState(undefined);
  window.panicButtons = panicButtons;
  window.setPanicButtons = panicButtons;




  const usePanicButtonsError = usePanicButtons(panicButtons, setPanicButtons, currentMarker);
  useEffect(() => {
    console.log("Error on usePanicButtons:");
    console.log(usePanicButtonsError); //I dunno do something else also //todo
  }, [usePanicButtonsError]);


  const [zoomView, setZoomView] = useState(
    {
      levelGroup: 3,
      layer: null,
      districtName: null,
      neighborhoodName: null,
      changeReason: "creation"
    }
  );
  /* because of leaflet events */
  window.zoomView = zoomView;
  window.alertedDistricts = useRef([]);
  /*
    [
      ...,
      {
        name: "Beşiktaş",
        deviceId: 9123912
      },
      ...
    ]
  */
  window.alertedNeighborhoods = useRef([]); 
  /*
    [
      ...,
      {
        name: "Levent",
        deviceId: 9123912
      },
      ...
    ]
  */
  /* because of leaflet events */

  const [zoomLevel, setZoomLevel] = useState(10);
  window.zoomLevel = zoomLevel;
  const [mapBounds, setMapBounds] = useState(null);
  const [devicesThatShouldSeen, setDevicesThatShouldSeen] = useState([]);
  const [fetchAccordingToChanges, setFetchAccordingToChanges] = useState(undefined);
  const [alertedDevices, setAlertedDevices] = useState([]);

  const [devicePopupShrinked, setDevicePopupShrinked] = useState(true);
  const [devicePopupInformation, setDevicePopupInformation] = useState({});
  window.devicePopupShrinked = devicePopupShrinked;
  window.setDevicePopupShrinked = setDevicePopupShrinked;
  window.devicePopupInformation = devicePopupInformation;
  window.setDevicePopupInformation = setDevicePopupInformation;

  window.devicesThatShouldSeen = devicesThatShouldSeen;
  

  const useDevicesError = useDevices(devices, setDevices, setDeviceDifference, loggedDevices, setLoggedDevices, dummyData, setDummyData, fetchAccordingToChanges, mapBounds);
  useEffect(() => {
    console.log("Error on useDevices:");
    console.log(useDevicesError); //I dunno do something else also //todo
  }, [useDevicesError]);

  const chooseDevicesThatShouldSeen = (zoomLevel, devices) => {

    if(zoomLevel < 14){
      return [];
    }
    return devices.Devices.filter((dev) => {
      if(dev.Status <= 1)
      {
        if(zoomLevel <= 17)
          return false;
        return true;
      }
      else {
        return true;
      }
    });
  }

  const isDevicesSame = (newDevices, oldDevices) => {

    if(newDevices.length != oldDevices?.length ?? 0)
      return false;

    let i;
    for(i = 0; i < newDevices.length; i++)
    {
      if(newDevices[i].ID != oldDevices[i].ID)
        return false;
      else if (newDevices[i].Status != oldDevices[i].Status)
        return false;
    }

    return true;
  }

  useEffect(() => {
  
    if(devices == null)
    {
      return;
    }

    
    let alertedOnes = devices.Devices.filter((dev) => { return dev.IsAlertIssued; });
    let same = isDevicesSame(alertedOnes, alertedDevices);
    if(!same)
    {
      setAlertedDevices(alertedOnes);
    }

    let devsToSee = chooseDevicesThatShouldSeen(zoomLevel,devices);
    
    same = isDevicesSame(devsToSee, devicesThatShouldSeen);
    if(!same)
    {
      setDevicesThatShouldSeen(devsToSee);
    }

  }, [devices])

  
  const onChange = () => {
    setFetchAccordingToChanges({});
  };

  const isReadyChangeLogger = useRef(false);
  window.isReadyChangeLogger = isReadyChangeLogger;


  const laziness = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  window.setIsLoading = setIsLoading;

  useLazyEffect(onChange, [zoomLevel, mapBounds, laziness], laziness);

  useEffect(() => {
    if(laziness.current != 400 && isReadyChangeLogger.current)
    {
      laziness.current = 400;
      setTimeout(() => {
        setIsLoading(false);
      },2000);
    }
  }, [isReadyChangeLogger]);



  const hiddenReset = () => {
    fetch(process.env.REACT_APP_API_ROOT_URL + "/device/reset", {
      method: "POST",
      body: JSON.stringify({
        devices: []
      })
    });
  };

  return (
  <React.Fragment>
      <Banner/>

      <div className="loader_comp" style={{position:"absolute"}}>
        <Loading loading={isLoading} background="var(--default-background-color)" loaderColor="var(--green-color)" />
      </div>
      
      <div className="hidden_button topright" onClick={hiddenReset}>

      </div>
      
      {
        //<div className="hidden_button botleft" onClick={CreateDevices}></div>
      }

      <div className="App">

      

        <div className="modal-body row fill">
          <MapContextProvider value={ 
              //if we were supposed to stay in long polling, this would be uglier than already is, but we gonna change into something that server pushes the changes
              //so when we do that, we won't need the half of the code.
              //so there is no need to split context into relevant parts for relavant components.
              {
                  zoomView: zoomView,
                  setZoomView: setZoomView,
                  zoomLevel: zoomLevel,
                  setZoomLevel: setZoomLevel,
                  mapBounds: mapBounds,
                  setMapBounds: setMapBounds,
                  devicesThatShouldSeen: devicesThatShouldSeen,
                  setDevicesThatShouldSeen: setDevicesThatShouldSeen,
                  alertedDevices: alertedDevices,
                  setAlertedDevices: setAlertedDevices,
                  deviceDifference: deviceDifference,
                  loggedDevices: loggedDevices,
                  dummyData: dummyData
              }
            }>
              
               
              <div className="fill no-padding" style={{position:"absolute"}}>
                <MapComponent/>
              </div>

              <div className="fill no-padding" style={{position:"absolute", margin:"0 !important", overflowX:"hidden !important",  display: "contents"}}>
                <div className="col-md-4 fill d-none d-sm-flex no-padding flex-column big-part" style={{position:"absolute", right: 0, zIndex: 686869, overflowX:"hidden"}}>
                  <InformationInterface/>
                </div>
              </div>
          </MapContextProvider>
        </div>
      </div>
    
    </React.Fragment>
  );
}



const LogoSvg = (style) => {
  return (
<svg width="16rem" height="4rem" viewBox="0 0 1200 300" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_b_585_6332)">
<rect width="1200" height="300" fill="#B5CBB7" fill-opacity="0.15"/>
</g>
<path d="M332.947 227.393L274.913 78.1096C274.341 76.5871 271.669 76.5871 271.096 78.1096L213.252 227.393C212.68 228.538 213.446 229.682 215.163 229.682H241.313C242.08 229.682 243.035 229.299 243.224 228.538L273.002 143.399L303.163 228.538C303.358 229.299 304.313 229.682 304.885 229.682H331.225C332.563 229.682 333.519 228.538 332.947 227.393Z" fill="white"/>
<path d="M192.35 76.7361H142.911C141.956 76.7361 141 77.6916 141 78.4528V104.797H192.35C195.789 104.797 214.878 105.753 214.878 122.553C214.878 139.353 196.167 139.731 192.35 139.731H141V227.737C141 228.498 141.956 229.453 142.911 229.453H167.728C169.061 229.453 169.633 228.498 169.633 227.737V167.986H192.35C195.978 167.986 243.895 167.414 243.895 122.553C243.895 77.6916 198.461 76.7361 192.35 76.7361Z" fill="white"/>
<path d="M371.328 144.697C360.45 139.542 349.761 139.542 348.805 139.542C339.067 139.542 329.716 133.814 329.716 122.742C329.716 110.525 338.305 104.225 348.805 104.225C358.733 104.225 367.133 109.38 367.511 120.264C367.511 120.836 368.467 121.786 369.611 121.786H393.472C394.811 121.786 395.767 120.836 395.572 120.264C395.194 94.2971 374.956 76.7358 348.805 76.7358C324.372 76.7358 301.272 94.1081 301.272 122.742C301.272 140.497 310.244 154.047 326.089 161.303C337.161 166.458 347.467 166.458 348.805 166.458C357.394 166.842 367.894 173.714 367.894 184.975C367.894 195.092 358.922 201.964 348.805 201.964C348.805 201.964 348.805 201.964 348.616 201.964V229.453C348.805 229.453 348.805 229.453 348.805 229.453C373.239 229.453 396.145 213.609 396.145 184.975C396.145 167.031 387.367 152.142 371.328 144.697Z" fill="white"/>
<path d="M266.496 74.3672V47H243.816L247.092 120.836L266.496 74.3672Z" fill="black"/>
<path d="M435.474 185V144.273H449.991C453.16 144.273 455.785 144.849 457.866 146.003C459.948 147.156 461.506 148.734 462.54 150.736C463.574 152.724 464.091 154.965 464.091 157.457C464.091 159.963 463.567 162.217 462.52 164.219C461.486 166.207 459.921 167.785 457.827 168.952C455.745 170.105 453.127 170.682 449.972 170.682H439.989V165.472H449.415C451.417 165.472 453.041 165.127 454.287 164.438C455.533 163.735 456.448 162.78 457.031 161.574C457.615 160.367 457.906 158.995 457.906 157.457C457.906 155.92 457.615 154.554 457.031 153.361C456.448 152.168 455.527 151.233 454.267 150.557C453.021 149.881 451.377 149.543 449.335 149.543H441.619V185H435.474ZM483.301 185.616C480.438 185.616 477.938 184.96 475.804 183.648C473.67 182.335 472.012 180.499 470.832 178.139C469.652 175.779 469.062 173.022 469.062 169.866C469.062 166.698 469.652 163.927 470.832 161.554C472.012 159.181 473.67 157.338 475.804 156.026C477.938 154.713 480.438 154.057 483.301 154.057C486.165 154.057 488.664 154.713 490.798 156.026C492.933 157.338 494.59 159.181 495.77 161.554C496.95 163.927 497.54 166.698 497.54 169.866C497.54 173.022 496.95 175.779 495.77 178.139C494.59 180.499 492.933 182.335 490.798 183.648C488.664 184.96 486.165 185.616 483.301 185.616ZM483.321 180.625C485.177 180.625 486.715 180.134 487.935 179.153C489.154 178.172 490.056 176.866 490.639 175.236C491.236 173.605 491.534 171.809 491.534 169.847C491.534 167.898 491.236 166.108 490.639 164.477C490.056 162.833 489.154 161.514 487.935 160.52C486.715 159.526 485.177 159.028 483.321 159.028C481.452 159.028 479.901 159.526 478.668 160.52C477.448 161.514 476.54 162.833 475.943 164.477C475.36 166.108 475.068 167.898 475.068 169.847C475.068 171.809 475.36 173.605 475.943 175.236C476.54 176.866 477.448 178.172 478.668 179.153C479.901 180.134 481.452 180.625 483.321 180.625ZM509.869 185L500.881 154.455H507.026L513.011 176.886H513.31L519.315 154.455H525.46L531.426 176.787H531.724L537.67 154.455H543.815L534.847 185H528.781L522.577 162.946H522.119L515.915 185H509.869ZM561.693 185.616C558.684 185.616 556.092 184.973 553.918 183.688C551.757 182.388 550.086 180.565 548.906 178.219C547.74 175.859 547.156 173.095 547.156 169.926C547.156 166.797 547.74 164.04 548.906 161.653C550.086 159.267 551.73 157.404 553.838 156.065C555.959 154.726 558.438 154.057 561.276 154.057C562.999 154.057 564.67 154.342 566.287 154.912C567.904 155.482 569.356 156.377 570.642 157.597C571.928 158.816 572.942 160.401 573.685 162.349C574.427 164.285 574.798 166.638 574.798 169.409V171.517H550.517V167.062H568.972C568.972 165.498 568.653 164.113 568.017 162.906C567.381 161.687 566.486 160.725 565.332 160.023C564.192 159.32 562.853 158.969 561.315 158.969C559.645 158.969 558.187 159.38 556.94 160.202C555.707 161.01 554.753 162.071 554.077 163.384C553.414 164.683 553.082 166.095 553.082 167.619V171.099C553.082 173.141 553.44 174.878 554.156 176.31C554.885 177.741 555.9 178.835 557.199 179.591C558.498 180.333 560.016 180.705 561.753 180.705C562.88 180.705 563.907 180.545 564.835 180.227C565.763 179.896 566.565 179.405 567.241 178.756C567.918 178.106 568.435 177.304 568.793 176.349L574.42 177.364C573.97 179.021 573.161 180.473 571.994 181.719C570.841 182.952 569.389 183.913 567.639 184.602C565.902 185.278 563.92 185.616 561.693 185.616ZM581.396 185V154.455H587.143V159.307H587.461C588.018 157.663 588.999 156.37 590.404 155.429C591.823 154.474 593.427 153.997 595.217 153.997C595.588 153.997 596.025 154.01 596.529 154.037C597.046 154.063 597.451 154.097 597.742 154.136V159.824C597.504 159.758 597.079 159.685 596.469 159.605C595.86 159.512 595.25 159.466 594.64 159.466C593.235 159.466 591.982 159.764 590.881 160.361C589.794 160.944 588.933 161.759 588.296 162.807C587.66 163.841 587.342 165.021 587.342 166.347V185H581.396ZM614.959 185.616C611.949 185.616 609.357 184.973 607.183 183.688C605.022 182.388 603.352 180.565 602.172 178.219C601.005 175.859 600.422 173.095 600.422 169.926C600.422 166.797 601.005 164.04 602.172 161.653C603.352 159.267 604.996 157.404 607.104 156.065C609.225 154.726 611.704 154.057 614.541 154.057C616.265 154.057 617.935 154.342 619.553 154.912C621.17 155.482 622.622 156.377 623.908 157.597C625.194 158.816 626.208 160.401 626.95 162.349C627.693 164.285 628.064 166.638 628.064 169.409V171.517H603.783V167.062H622.237C622.237 165.498 621.919 164.113 621.283 162.906C620.646 161.687 619.751 160.725 618.598 160.023C617.458 159.32 616.119 158.969 614.581 158.969C612.911 158.969 611.452 159.38 610.206 160.202C608.973 161.01 608.018 162.071 607.342 163.384C606.679 164.683 606.348 166.095 606.348 167.619V171.099C606.348 173.141 606.706 174.878 607.422 176.31C608.151 177.741 609.165 178.835 610.464 179.591C611.764 180.333 613.282 180.705 615.018 180.705C616.145 180.705 617.173 180.545 618.101 180.227C619.029 179.896 619.831 179.405 620.507 178.756C621.183 178.106 621.7 177.304 622.058 176.349L627.686 177.364C627.235 179.021 626.427 180.473 625.26 181.719C624.107 182.952 622.655 183.913 620.905 184.602C619.168 185.278 617.186 185.616 614.959 185.616ZM646.096 185.597C643.63 185.597 641.429 184.967 639.494 183.707C637.571 182.435 636.06 180.625 634.96 178.278C633.872 175.919 633.329 173.088 633.329 169.787C633.329 166.486 633.879 163.662 634.979 161.315C636.093 158.969 637.618 157.172 639.553 155.926C641.489 154.68 643.683 154.057 646.136 154.057C648.031 154.057 649.556 154.375 650.71 155.011C651.876 155.634 652.778 156.364 653.414 157.199C654.064 158.034 654.567 158.77 654.925 159.406H655.283V144.273H661.229V185H655.423V180.247H654.925C654.567 180.897 654.05 181.639 653.374 182.474C652.711 183.31 651.797 184.039 650.63 184.662C649.463 185.285 647.952 185.597 646.096 185.597ZM647.408 180.526C649.119 180.526 650.564 180.075 651.744 179.173C652.937 178.259 653.838 176.992 654.448 175.375C655.071 173.758 655.383 171.875 655.383 169.727C655.383 167.606 655.078 165.75 654.468 164.159C653.858 162.568 652.963 161.329 651.783 160.44C650.603 159.552 649.145 159.108 647.408 159.108C645.619 159.108 644.127 159.572 642.934 160.5C641.741 161.428 640.839 162.694 640.229 164.298C639.633 165.902 639.335 167.712 639.335 169.727C639.335 171.769 639.639 173.605 640.249 175.236C640.859 176.866 641.761 178.159 642.954 179.114C644.16 180.055 645.645 180.526 647.408 180.526ZM685.013 185V144.273H690.96V159.406H691.317C691.662 158.77 692.159 158.034 692.809 157.199C693.459 156.364 694.36 155.634 695.513 155.011C696.667 154.375 698.192 154.057 700.087 154.057C702.553 154.057 704.754 154.68 706.69 155.926C708.625 157.172 710.143 158.969 711.244 161.315C712.357 163.662 712.914 166.486 712.914 169.787C712.914 173.088 712.364 175.919 711.263 178.278C710.163 180.625 708.652 182.435 706.729 183.707C704.807 184.967 702.613 185.597 700.147 185.597C698.291 185.597 696.773 185.285 695.593 184.662C694.426 184.039 693.512 183.31 692.849 182.474C692.186 181.639 691.675 180.897 691.317 180.247H690.82V185H685.013ZM690.84 169.727C690.84 171.875 691.152 173.758 691.775 175.375C692.398 176.992 693.299 178.259 694.479 179.173C695.659 180.075 697.104 180.526 698.815 180.526C700.591 180.526 702.076 180.055 703.269 179.114C704.462 178.159 705.364 176.866 705.974 175.236C706.597 173.605 706.908 171.769 706.908 169.727C706.908 167.712 706.603 165.902 705.994 164.298C705.397 162.694 704.496 161.428 703.289 160.5C702.096 159.572 700.604 159.108 698.815 159.108C697.091 159.108 695.633 159.552 694.44 160.44C693.26 161.329 692.365 162.568 691.755 164.159C691.145 165.75 690.84 167.606 690.84 169.727ZM722.31 196.455C721.422 196.455 720.613 196.382 719.884 196.236C719.155 196.103 718.612 195.957 718.254 195.798L719.685 190.926C720.772 191.218 721.74 191.344 722.589 191.304C723.437 191.264 724.186 190.946 724.836 190.349C725.499 189.753 726.082 188.778 726.586 187.426L727.322 185.398L716.146 154.455H722.509L730.245 178.159H730.563L738.299 154.455H744.683L732.094 189.077C731.511 190.668 730.769 192.013 729.867 193.114C728.966 194.227 727.892 195.063 726.646 195.619C725.399 196.176 723.954 196.455 722.31 196.455Z" fill="white"/>
<g clip-path="url(#clip0_585_6332)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M885.924 195.92H867.804V138.882H885.924V195.92ZM833.188 195.92C835.236 195.968 837.069 195.983 838.682 195.953C840.298 195.931 841.742 195.833 843.006 195.672C844.269 195.511 845.402 195.256 846.399 194.903C847.393 194.555 848.323 194.082 849.186 193.493C849.887 193.006 850.449 192.548 850.881 192.117C851.312 191.69 851.638 191.337 851.852 191.071C852.714 190.1 853.494 188.832 854.192 187.272C854.893 185.708 855.246 183.556 855.246 180.807C855.246 177.413 854.882 174.897 854.154 173.255C853.427 171.612 852.418 170.33 851.124 169.418C849.939 168.503 848.687 167.896 847.367 167.6C846.051 167.303 844.686 167.048 843.287 166.831C844.311 166.561 845.334 166.253 846.358 165.901C847.382 165.552 848.349 165.001 849.268 164.247C849.857 163.76 850.386 163.223 850.839 162.631C851.301 162.038 851.687 161.326 852.013 160.49C852.336 159.657 852.591 158.66 852.782 157.501C852.969 156.342 853.063 154.985 853.063 153.421C853.063 150.458 852.647 148.13 851.811 146.431C850.978 144.736 850.022 143.457 848.942 142.595C847.918 141.68 846.801 140.978 845.589 140.495C844.378 140.011 843.111 139.647 841.794 139.403C840.474 139.163 839.139 139.013 837.793 138.961C836.447 138.905 835.127 138.878 833.837 138.878H781.161V195.92H833.188ZM981.76 177.173C981.76 178.253 981.775 179.42 981.801 180.687C981.827 181.955 981.936 183.233 982.123 184.527C982.315 185.817 982.622 187.055 983.053 188.24C983.485 189.425 984.103 190.452 984.91 191.311C985.611 192.065 986.391 192.695 987.253 193.208C988.116 193.722 989.031 194.138 989.998 194.461C990.97 194.787 991.941 195.027 992.908 195.188L995.818 195.672C999.692 195.89 1003.52 196.092 1007.29 196.276C1011.06 196.467 1014.85 196.561 1018.68 196.561C1022.23 196.561 1025.74 196.493 1029.19 196.362C1032.63 196.227 1036.13 196.051 1039.69 195.833C1041.46 195.567 1043.18 195.23 1044.85 194.825C1046.53 194.42 1048.03 193.737 1049.38 192.766C1049.86 192.387 1050.28 192.012 1050.63 191.633C1050.98 191.255 1051.35 190.827 1051.72 190.34C1052.64 189.102 1053.35 187.595 1053.86 185.817C1054.37 184.04 1054.63 181.535 1054.63 178.302C1054.63 176.202 1054.48 174.383 1054.19 172.85C1053.89 171.316 1053.49 169.996 1052.97 168.893C1052.47 167.787 1051.87 166.861 1051.2 166.103C1050.52 165.35 1049.84 164.705 1049.14 164.165C1048.65 163.79 1048.15 163.463 1047.64 163.197C1047.13 162.927 1046.55 162.698 1045.91 162.507C1045.26 162.323 1044.52 162.147 1043.69 161.986C1042.85 161.821 1041.84 161.69 1040.65 161.581L1006.4 160.37C1005.32 160.261 1004.3 160.111 1003.33 159.923C1002.36 159.736 1001.5 159.143 1000.75 158.172C1000.58 158 1000.38 157.688 1000.14 157.231C999.898 156.773 999.775 156.233 999.775 155.641C999.775 155.052 999.91 154.497 1000.18 154.013C1000.45 153.526 1000.64 153.192 1000.75 153.031C1001.44 152.112 1002.28 151.561 1003.25 151.403C1004.22 151.242 1005.24 151.13 1006.32 151.077C1007.99 151.025 1009.63 150.972 1011.25 150.916C1012.86 150.863 1014.5 150.837 1016.18 150.837C1018.27 150.837 1020.39 150.875 1022.52 150.957C1024.65 151.036 1026.76 151.13 1028.86 151.242C1029.99 151.347 1030.92 151.493 1031.65 151.685C1032.37 151.872 1032.97 152.142 1033.42 152.495C1033.88 152.84 1034.24 153.353 1034.51 154.028C1034.78 154.7 1035.05 155.577 1035.32 156.653L1052.61 156.732C1052.66 155.495 1052.68 154.242 1052.65 152.975C1052.63 151.711 1052.49 150.5 1052.25 149.356C1052 148.197 1051.61 147.091 1051.07 146.015C1050.54 144.95 1049.78 143.956 1048.81 143.052C1048.06 142.351 1047.26 141.773 1046.43 141.327C1045.6 140.87 1044.79 140.495 1044.01 140.198C1043.23 139.902 1042.54 139.7 1041.95 139.595C1041.35 139.486 1040.9 139.403 1040.57 139.351L1037.42 138.878C1033.98 138.717 1030.54 138.556 1027.12 138.395C1023.7 138.233 1020.27 138.151 1016.83 138.151C1013.7 138.151 1010.59 138.203 1007.49 138.312C1004.39 138.421 1001.28 138.53 998.158 138.638C995.736 138.905 993.475 139.31 991.375 139.846C989.275 140.39 987.388 141.545 985.72 143.322C984.692 144.398 983.912 145.613 983.376 146.956C982.997 147.875 982.716 148.898 982.528 150.027C982.337 151.16 982.202 152.251 982.123 153.301C982.041 154.351 981.988 155.24 981.962 155.967C981.936 156.695 981.921 157.111 981.921 157.216C981.921 160.126 982.258 162.485 982.933 164.288C983.605 166.092 984.4 167.48 985.315 168.447C986.016 169.201 986.755 169.808 987.535 170.266C988.318 170.723 989.083 171.098 989.837 171.398C990.595 171.695 991.266 171.893 991.855 172.002C992.451 172.111 992.882 172.19 993.152 172.246C993.58 172.351 994 172.418 994.401 172.448C994.81 172.475 995.226 172.538 995.653 172.651C997 172.756 998.335 172.85 999.655 172.932C1000.97 173.011 1002.31 173.108 1003.65 173.213C1007.85 173.483 1012.04 173.645 1016.22 173.701C1020.39 173.75 1024.58 173.832 1028.78 173.941C1030.82 174.211 1032.36 174.44 1033.39 174.627C1034.41 174.818 1035.27 175.396 1035.97 176.367C1036.35 176.903 1036.57 177.387 1036.66 177.818C1036.73 178.253 1036.78 178.598 1036.78 178.868C1036.78 179.84 1036.45 180.728 1035.81 181.535C1035.16 182.341 1034.38 182.907 1033.46 183.233C1032.55 183.608 1031.58 183.785 1030.56 183.755C1029.53 183.732 1028.89 183.717 1028.62 183.717C1026.62 183.77 1024.66 183.826 1022.72 183.878C1020.78 183.931 1018.84 183.931 1016.9 183.878C1015.07 183.826 1013.27 183.77 1011.49 183.717C1009.71 183.665 1007.91 183.582 1006.07 183.473C1004.19 183.312 1002.79 183.016 1001.87 182.585C1000.96 182.157 1000.34 181.482 1000.02 180.567C999.805 180.08 999.681 179.57 999.655 179.033C999.628 178.493 999.613 177.901 999.613 177.252L981.76 177.173ZM897.579 177.173C897.579 178.253 897.594 179.42 897.621 180.687C897.643 181.955 897.756 183.233 897.939 184.527C898.127 185.817 898.438 187.055 898.873 188.24C899.301 189.425 899.923 190.452 900.73 191.311C901.427 192.065 902.211 192.695 903.073 193.208C903.932 193.722 904.847 194.138 905.818 194.461C906.789 194.787 907.757 195.027 908.725 195.188C909.696 195.35 910.667 195.511 911.635 195.672C915.512 195.89 919.337 196.092 923.106 196.276C926.875 196.467 930.673 196.561 934.498 196.561C938.053 196.561 941.552 196.493 945.002 196.362C948.448 196.227 951.951 196.051 955.502 195.833C957.283 195.567 959.005 195.23 960.673 194.825C962.342 194.42 963.853 193.737 965.2 192.766C965.683 192.387 966.1 192.012 966.452 191.633C966.801 191.255 967.161 190.827 967.54 190.34C968.455 189.102 969.171 187.595 969.681 185.817C970.195 184.04 970.45 181.535 970.45 178.302C970.45 176.202 970.3 174.383 970.003 172.85C969.707 171.316 969.306 169.996 968.792 168.893C968.282 167.787 967.69 166.861 967.015 166.103C966.343 165.35 965.653 164.705 964.956 164.165C964.472 163.79 963.973 163.463 963.46 163.197C962.946 162.927 962.368 162.698 961.723 162.507C961.078 162.323 960.336 162.147 959.5 161.986C958.667 161.821 957.655 161.69 956.473 161.581L922.217 160.37C921.141 160.261 920.121 160.111 919.15 159.923C918.178 159.736 917.316 159.143 916.562 158.172C916.401 158 916.202 157.688 915.958 157.231C915.715 156.773 915.595 156.233 915.595 155.641C915.595 155.052 915.73 154.497 916 154.013C916.266 153.526 916.457 153.192 916.562 153.031C917.263 152.112 918.096 151.561 919.067 151.403C920.038 151.242 921.062 151.13 922.138 151.077C923.807 151.025 925.45 150.972 927.066 150.916C928.682 150.863 930.325 150.837 931.997 150.837C934.093 150.837 936.208 150.875 938.338 150.957C940.461 151.036 942.58 151.13 944.676 151.242C945.808 151.347 946.738 151.493 947.466 151.685C948.193 151.872 948.786 152.142 949.24 152.495C949.697 152.84 950.065 153.353 950.335 154.028C950.601 154.7 950.871 155.577 951.141 156.653L968.428 156.732C968.485 155.495 968.496 154.242 968.47 152.975C968.443 151.711 968.308 150.5 968.068 149.356C967.825 148.197 967.435 147.091 966.895 146.015C966.358 144.95 965.601 143.956 964.633 143.052C963.876 142.351 963.085 141.773 962.248 141.327C961.412 140.87 960.606 140.495 959.826 140.198C959.042 139.902 958.36 139.7 957.767 139.595C957.171 139.486 956.713 139.403 956.391 139.351L953.245 138.878C949.795 138.717 946.363 138.556 942.94 138.395C939.52 138.233 936.085 138.151 932.638 138.151C929.515 138.151 926.406 138.203 923.308 138.312C920.211 138.421 917.102 138.53 913.978 138.638C911.552 138.905 909.295 139.31 907.191 139.846C905.091 140.39 903.208 141.545 901.536 143.322C900.512 144.398 899.732 145.613 899.192 146.956C898.817 147.875 898.536 148.898 898.344 150.027C898.157 151.16 898.022 152.251 897.939 153.301C897.861 154.351 897.804 155.24 897.782 155.967C897.756 156.695 897.741 157.111 897.741 157.216C897.741 160.126 898.078 162.485 898.75 164.288C899.421 166.092 900.216 167.48 901.131 168.447C901.836 169.201 902.575 169.808 903.354 170.266C904.134 170.723 904.903 171.098 905.657 171.398C906.411 171.695 907.086 171.893 907.675 172.002C908.267 172.111 908.702 172.19 908.968 172.246C909.4 172.351 909.816 172.418 910.221 172.448C910.626 172.475 911.046 172.538 911.473 172.651C912.82 172.756 914.155 172.85 915.471 172.932C916.791 173.011 918.122 173.108 919.472 173.213C923.672 173.483 927.861 173.645 932.035 173.701C936.208 173.75 940.397 173.832 944.597 173.941C946.645 174.211 948.178 174.44 949.202 174.627C950.226 174.818 951.085 175.396 951.79 176.367C952.161 176.903 952.393 177.387 952.472 177.818C952.555 178.253 952.596 178.598 952.596 178.868C952.596 179.84 952.273 180.728 951.625 181.535C950.98 182.341 950.2 182.907 949.285 183.233C948.37 183.608 947.398 183.785 946.375 183.755C945.351 183.732 944.706 183.717 944.436 183.717C942.445 183.77 940.476 183.826 938.541 183.878C936.598 183.931 934.66 183.931 932.721 183.878C930.891 183.826 929.083 183.77 927.31 183.717C925.532 183.665 923.725 183.582 921.895 183.473C920.008 183.312 918.609 183.016 917.695 182.585C916.779 182.157 916.161 181.482 915.835 180.567C915.621 180.08 915.497 179.57 915.471 179.033C915.445 178.493 915.433 177.901 915.433 177.252L897.579 177.173ZM798.452 151.321H828.583C829.821 151.373 830.927 151.482 831.898 151.643C832.866 151.805 833.728 152.423 834.482 153.503C835.183 154.366 835.532 155.333 835.532 156.41C835.532 157.163 835.397 157.797 835.127 158.307C834.861 158.821 834.643 159.185 834.482 159.398C833.728 160.475 832.813 161.082 831.737 161.217C830.661 161.352 829.472 161.393 828.178 161.337H798.452V151.321ZM798.369 172.73H829.798C831.141 172.673 832.382 172.73 833.511 172.891C834.643 173.052 835.667 173.727 836.582 174.908C836.904 175.396 837.159 175.88 837.351 176.367C837.538 176.851 837.632 177.413 837.632 178.062C837.632 178.546 837.591 178.947 837.512 179.273C837.429 179.596 837.366 179.84 837.309 179.997C836.878 181.081 836.259 181.805 835.449 182.183C834.643 182.558 833.676 182.855 832.543 183.072H798.369V172.73Z" fill="white"/>
</g>
<defs>
<filter id="filter0_b_585_6332" x="-15" y="-15" width="1230" height="330" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feGaussianBlur in="BackgroundImageFix" stdDeviation="7.5"/>
<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_585_6332"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_585_6332" result="shape"/>
</filter>
<clipPath id="clip0_585_6332">
<rect width="276" height="144" fill="white" transform="translate(782 96)"/>
</clipPath>
</defs>
</svg>

  )
}


const Banner = () => {


  return (
    <div style={{position: "absolute", zIndex: 999999, backgroundColor: "rgba(0,0,0,0.3)", backdropFilter: "blur(4.5px)"}}>
      <LogoSvg/>
    </div>
  )

}